{
  "panel": {
    "title": "Notas",
    "newNote_title": "Nueva nota",
    "search_placeholder": "Buscar notas…",
    "search_aria": "Buscar notas",
    "clearSearch_aria": "Borrar búsqueda",
    "editorPlaceholder": "¿Qué tienes en mente…",
    "titleInput_placeholder": "Sin título",
    "untitled": "Sin título",
    "emptyNote": "Nota vacía",
    "loadingNotes": "Cargando notas…",
    "noNotesYet": "Aún no hay notas. Toca + para crear una.",
    "noResults": "Sin resultados para \"{{query}}\"",
    "noNotesTagged": "No hay notas etiquetadas con {{tag}}",
    "tagFilterAll": "Todas",
    "filterByTag_aria": "Filtrar por etiqueta",
    "templates": "Plantillas",
    "editorTheme_aria": "Tema del editor",
    "themeActive_aria": "Tema {{theme}} (activo)",
    "theme_aria": "Tema {{theme}}",
    "themeName": {
      "dark": "Oscuro",
      "sepia": "Sepia",
      "light": "Claro",
      "forest": "Bosque"
    },
    "voice": "Voz",
    "voice_title": "Nota de voz",
    "voiceUnavailable_title": "Voz no disponible en este navegador",
    "openVoiceRecorder_aria": "Abrir grabadora de notas de voz",
    "summarizing_title": "Resumiendo…",
    "summarize_title": "Resumir",
    "summarizeNote_aria": "Resumir nota",
    "aiCommands_title": "Comandos de IA  Cmd+K",
    "openAiPalette_aria": "Abrir paleta de comandos de IA",
    "enterFocusMode_title": "Modo concentración  Cmd+Shift+F",
    "exitFocusMode_title": "Salir del modo concentración  Cmd+Shift+F",
    "enterFocusMode_aria": "Entrar en modo concentración",
    "exitFocusMode_aria": "Salir del modo concentración",
    "export_title": "Exportar nota",
    "delete_title": "Eliminar nota",
    "delete_aria": "Eliminar nota",
    "moreActions_title": "Más acciones",
    "wordCount_one": "{{formatted}} palabra · ~{{minutes}} min de lectura",
    "wordCount_other": "{{formatted}} palabras · ~{{minutes}} min de lectura",
    "referencedBy_one": "Referenciada por {{count}}",
    "referencedBy_other": "Referenciada por {{count}}",
    "noMatchingNotes": "No hay notas que coincidan",
    "mobileTabs_aria": "Vista de notas",
    "mobileTabNotes": "Notas",
    "mobileTabEditor": "Editor",
    "saveFailed": "No se pudo guardar la nota: {{message}}",
    "deleteFailed": "No se pudo eliminar la nota",
    "loadFailed": "No se pudieron cargar las notas",
    "analyzeFailed": "No se pudo analizar la nota",
    "aiCommandFailed": "El comando de IA falló",
    "unknownError": "Error desconocido"
  },
  "paywall": {
    "title": "Notas forma parte de Rhemn Pro",
    "safariBody": "Desbloquea notas sincronizadas, dictado y resúmenes con IA con Rhemn Pro. ¿Ya eres miembro? Se desbloquea automáticamente al iniciar sesión.",
    "body": "Desbloquea notas sincronizadas, dictado desde el navegador y resúmenes de IA estructurados."
  },
  "format": {
    "bold": "Negrita",
    "italic": "Cursiva",
    "strikethrough": "Tachado",
    "inlineCode": "Código en línea",
    "heading1": "Encabezado 1",
    "heading2": "Encabezado 2",
    "heading3": "Encabezado 3",
    "bulletList": "Lista con viñetas",
    "numberedList": "Lista numerada",
    "blockquote": "Cita",
    "codeBlock": "Bloque de código",
    "toggleBold_aria": "Alternar negrita",
    "toggleItalic_aria": "Alternar cursiva",
    "toggleStrikethrough_aria": "Alternar tachado",
    "toggleInlineCode_aria": "Alternar código en línea",
    "toggleBulletList_aria": "Alternar lista con viñetas",
    "toggleNumberedList_aria": "Alternar lista numerada",
    "toggleBlockquote_aria": "Alternar cita",
    "formatOptions_aria": "Opciones de formato"
  },
  "analysis": {
    "heading": "Resumen",
    "onDevice": "⚡ En el dispositivo",
    "onDevice_aria": "Procesado en el dispositivo",
    "applyToNote_title": "Aplicar a la nota",
    "applyToNote_aria": "Aplicar resumen a la nota",
    "summaryLabel": "Resumen",
    "keyPointsLabel": "Puntos clave",
    "noKeyPoints": "No se devolvieron puntos clave para esta nota."
  },
  "export": {
    "markdown": "Exportar como Markdown",
    "plainText": "Exportar como texto sin formato",
    "pdf": "Exportar como PDF",
    "allZip": "Exportar todo como ZIP",
    "label": "Exportar"
  },
  "cmdk": {
    "dialog_aria": "Paleta de comandos de IA",
    "input_placeholder": "Pregunta a la IA o ejecuta un comando…",
    "esc": "Esc",
    "back_aria": "Atrás",
    "translateTo": "Traducir a",
    "language_placeholder": "Idioma…",
    "aiActions": "Acciones de IA",
    "noCommandsMatch": "Ningún comando coincide con \"{{query}}\"",
    "continue": {
      "label": "Continuar escribiendo",
      "description": "Continúa desde donde lo dejaste"
    },
    "summarize": {
      "label": "Resumir selección",
      "description": "Condensar en puntos clave"
    },
    "formal": {
      "label": "Hacer esto formal",
      "description": "Eleva el tono a profesional"
    },
    "simplify": {
      "label": "Simplificar",
      "description": "Lenguaje más corto y claro"
    },
    "translate": {
      "label": "Traducir a…",
      "description": "Traducir a otro idioma"
    },
    "expand": {
      "label": "Expandir esta viñeta",
      "description": "Convierte la viñeta seleccionada en prosa"
    },
    "languages": {
      "Spanish": "Español",
      "Arabic": "Árabe",
      "French": "Francés",
      "German": "Alemán",
      "Japanese": "Japonés",
      "Portuguese": "Portugués"
    }
  },
  "templates": {
    "dialog_aria": "Elegir plantilla",
    "header": "Elige una plantilla",
    "builtInLabel": "Integradas",
    "myTemplatesLabel": "Mis plantillas",
    "saveCurrent": "Guardar la nota actual como plantilla",
    "myTemplatesEmpty": "Tus plantillas guardadas aparecerán aquí",
    "useTemplate": "Usar plantilla",
    "meeting": {
      "name": "Notas de reunión",
      "description": "Captura decisiones y elementos de acción",
      "structure": "Asistentes / Agenda / Notas / Acciones"
    },
    "journal": {
      "name": "Diario personal",
      "description": "Reflexiona sobre tu día",
      "structure": "Gratitud / Logros de hoy / Notas"
    },
    "book": {
      "name": "Resumen de libro",
      "description": "Captura las ideas clave de un libro",
      "structure": "Idea central / Citas clave / Aprendizajes"
    },
    "project": {
      "name": "Resumen de proyecto",
      "description": "Esboza el alcance, los objetivos y las partes interesadas",
      "structure": "Objetivo / Alcance / Riesgos / Cronograma"
    },
    "brainstorm": {
      "name": "Lluvia de ideas",
      "description": "Captura libre de ideas",
      "structure": "Tema / Ideas / Próximos pasos"
    },
    "weekly": {
      "name": "Revisión semanal",
      "description": "Revisa y planifica tu semana",
      "structure": "Logros / Dificultades / Áreas de enfoque"
    }
  },
  "voice": {
    "dialog_aria": "Grabadora de notas de voz",
    "cancel_aria": "Cancelar",
    "statusRecording": "Grabando",
    "statusTranscribing": "Transcribiendo…",
    "statusReview": "Revisar",
    "skip": "Omitir",
    "mark": "Marcar",
    "mark_title": "Añadir un marcador de tiempo",
    "captureMeeting": "Capturar reunión",
    "captureMeeting_title": "Captura también el audio de una pestaña de reunión",
    "meeting": "Reunión",
    "meeting_title": "Capturando la pestaña de la reunión",
    "markers_aria": "Marcadores de tiempo",
    "listening": "Escuchando…",
    "micDenied": "El acceso al micrófono está desactivado. Permítelo en Ajustes e inténtalo de nuevo.",
    "captureFailed": "No se pudo iniciar la grabación. Inténtalo de nuevo en un momento.",
    "tabPicker_aria": "Elige una pestaña de reunión para capturar",
    "captureFrom": "Capturar audio de…",
    "noAudibleTab": "Ninguna pestaña está reproduciendo audio. Abre tu reunión y asegúrate de que alguien esté hablando, luego inténtalo de nuevo.",
    "tabPickerCancel": "Cancelar",
    "tabTranscript": "Transcripción",
    "structuring": "Estructurando…",
    "structuredNote": "Nota estructurada",
    "structureFailed": "No se pudo crear la nota estructurada.",
    "retryStructure": "Reintentar",
    "browserTranscript": "Transcripción del navegador",
    "nothingCaptured": "No se capturó nada.",
    "buildingStructured": "Construyendo nota estructurada…",
    "cancel": "Cancelar",
    "stop": "Detener",
    "recordAgain": "Grabar de nuevo",
    "saveToNote": "Guardar en la nota",
    "statusMeeting": "Reunión",
    "captureStrip_aria": "Capturando audio de {{tab}}",
    "stopCapture": "Detener captura",
    "stopCapture_title": "Deja de capturar la pestaña — el micrófono sigue grabando",
    "stopsIn": "Se detiene en {{time}}",
    "autoStopped": "La grabación se detuvo al llegar al límite de 60 minutos.",
    "autoStoppedQuota": "La grabación se detuvo — has usado los minutos de transcripción de este mes.",
    "captureLost": "La pestaña de la reunión se cerró. Tu micrófono sigue grabando.",
    "tabSummary": "Resumen",
    "noSpeakers": "Hablantes no identificados",
    "speakerN": "Hablante {{number}}",
    "renameSpeaker_aria": "Renombrar a {{name}} — se aplica a todas sus intervenciones",
    "renameSpeaker_input_aria": "Nombre del hablante",
    "turnTime_title": "Dicho en {{time}}",
    "actionItemsTitle": "Acciones pendientes",
    "actionsCount": "{{checked}} de {{total}}",
    "addToTasks_one": "Añadir {{count}} a Tareas",
    "addToTasks_other": "Añadir {{count}} a Tareas",
    "addToTasksZero": "Añadir a Tareas",
    "adding": "Añadiendo…",
    "tasksAdded_one": "{{count}} tarea añadida",
    "tasksAdded_other": "{{count}} tareas añadidas",
    "viewTasks": "Ver",
    "addFailed": "No se pudo añadir — inténtalo de nuevo.",
    "minutesLeft_one": "{{count}} min restante",
    "minutesLeft_other": "{{count}} min restantes",
    "minutesLeftShort_one": "{{count}} min restante",
    "minutesLeftShort_other": "{{count}} min restantes",
    "minutesLeft_title": "{{count}} minutos de transcripción restantes este mes",
    "quotaExhausted": "Has usado los minutos de reunión de este mes. Se renuevan el {{date}}.",
    "quotaUnknown": "Minutos restantes desconocidos — la grabación puede alcanzar tu límite mensual",
    "meetingProRequired": "La transcripción de reuniones es parte de Pro. Tu transcripción en vivo se conserva abajo.",
    "gateTitle": "Grabación de reuniones",
    "gateBody": "Graba la pestaña de una reunión junto con tu micrófono — con hablantes identificados y acciones extraídas. Incluido con Pro.",
    "gateLater": "Ahora no",
    "gateCta": "Ver Pro",
    "roomOption": "Sin pestaña — graba la sala",
    "roomHint": "Una llamada en altavoz, una app nativa o gente en la sala — todo lo que puedas oír en voz alta.",
    "roomHint_title": "Si la otra parte está en tus auriculares, el micrófono no puede oírla — usa el altavoz.",
    "recordRoom": "Grabar la sala",
    "recordRoom_title": "Graba a todos los que el micrófono pueda oír — con hablantes identificados",
    "roomStart": "Empezar",
    "statusRoom": "Sala",
    "roomStrip": "Grabando la sala",
    "roomStrip_aria": "Grabando la sala — todos los que el micrófono oye",
    "roomOff": "Desactivar",
    "roomOff_title": "Desactiva el modo sala — esto pasa a ser una nota de voz normal",
    "roomRenameHint": "Toca un nombre para renombrarlo — uno de ellos eres tú.",
    "gateBodyRoom": "Graba lo que se dice a tu alrededor — con hablantes identificados y acciones extraídas. Incluido con Pro.",
    "roomHintDevice": "Las llamadas en este dispositivo no se pueden grabar — iOS las mantiene privadas. Otro teléfono en altavoz, o una conversación en la sala, sí funciona.",
    "autoStoppedSize": "La grabación se detuvo al llegar al límite de tamaño de subida.",
    "tooLarge": "La grabación era demasiado grande para subirla, así que no se pudo transcribir.",
    "destTo": "En",
    "dest_aria": "Añadir a la lista: {{name}}",
    "destMenu_aria": "Elige una lista",
    "destNewPending_aria": "Lista nueva: {{name}}"
  },
  "meetingNotice": {
    "title": "Reuniones, en tus notas",
    "body": "Rhemn ahora puede grabar una pestaña de reunión que tú elijas — solo mientras grabas una nota de voz, y solo la pestaña que selecciones.",
    "factPrivacy": "El audio se procesa para crear tu transcripción y luego se descarta. Las grabaciones nunca se almacenan.",
    "factControl": "No se captura nada hasta que pulsas grabar y eliges una pestaña.",
    "cta": "Entendido",
    "privacyLink": "Lee nuestra política de privacidad",
    "dialog_aria": "Acerca del nuevo permiso de grabación de reuniones"
  }
}
